import { useEffect } from 'react';
import { useFormState, useWatch } from 'react-hook-form';

import { InvoiceDiscrepanciesServiceSingleton } from '.';
import { ConfigItem } from './types';

/**
 * Hook for managing document-level errors with UI configuration.
 * Organizes errors according to the UI configuration.
 */
export const useDiscrepancies = <TSection extends ConfigItem>(uiConfig: Array<TSection> | undefined) => {
  const formState = useFormState();
  const formData = useWatch();
  useEffect(() => {
    InvoiceDiscrepanciesServiceSingleton.processDocumentDiscrepancies(formState.errors, formData || {}, uiConfig);
  }, [formData, formState, uiConfig]);
};
